"use strict";

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NamespaceHttp = void 0;

var operators_1 = require("rxjs/operators");

var symbol_openapi_typescript_fetch_client_1 = require("symbol-openapi-typescript-fetch-client");

var format_1 = require("../core/format");

var DtoMapping_1 = require("../core/utils/DtoMapping");

var AccountNames_1 = require("../model/account/AccountNames");

var Address_1 = require("../model/account/Address");

var MosaicId_1 = require("../model/mosaic/MosaicId");

var MosaicNames_1 = require("../model/mosaic/MosaicNames");

var AddressAlias_1 = require("../model/namespace/AddressAlias");

var AliasType_1 = require("../model/namespace/AliasType");

var EmptyAlias_1 = require("../model/namespace/EmptyAlias");

var MosaicAlias_1 = require("../model/namespace/MosaicAlias");

var NamespaceId_1 = require("../model/namespace/NamespaceId");

var NamespaceInfo_1 = require("../model/namespace/NamespaceInfo");

var NamespaceName_1 = require("../model/namespace/NamespaceName");

var UInt64_1 = require("../model/UInt64");

var Http_1 = require("./Http");

var paginationStreamer_1 = require("./paginationStreamer");
/**
 * Namespace http repository.
 *
 * @since 1.0
 */


var NamespaceHttp = /*#__PURE__*/function (_Http_1$Http) {
  _inherits(NamespaceHttp, _Http_1$Http);

  var _super = _createSuper(NamespaceHttp);

  /**
   * Constructor
   * @param url Base catapult-rest url
   * @param networkType the network type.
   * @param fetchApi fetch function to be used when performing rest requests.
   */
  function NamespaceHttp(url, networkType, fetchApi) {
    var _this;

    _classCallCheck(this, NamespaceHttp);

    _this = _super.call(this, url, fetchApi);
    _this.namespaceRoutesApi = new symbol_openapi_typescript_fetch_client_1.NamespaceRoutesApi(_this.config());
    _this.networkTypeObservable = _this.createNetworkTypeObservable(networkType);
    return _this;
  }
  /**
   * Returns friendly names for array of addresses.
   * @summary Get readable names for a set of array of addresses
   * @param addresses - Array of addresses
   */


  _createClass(NamespaceHttp, [{
    key: "getAccountsNames",
    value: function getAccountsNames(addresses) {
      var accountIdsBody = {
        addresses: addresses.map(function (address) {
          return address.plain();
        })
      };
      return this.call(this.namespaceRoutesApi.getAccountsNames(accountIdsBody), function (body) {
        return body.accountNames.map(function (accountName) {
          return new AccountNames_1.AccountNames(DtoMapping_1.DtoMapping.toAddress(accountName.address), accountName.names.map(function (name) {
            return new NamespaceName_1.NamespaceName(new NamespaceId_1.NamespaceId(name), name);
          }));
        });
      });
    }
    /**
     * Get readable names for a set of mosaics
     * Returns friendly names for mosaics.
     * @param mosaicIds - Array of mosaic ids
     * @return Observable<MosaicNames[]>
     */

  }, {
    key: "getMosaicsNames",
    value: function getMosaicsNames(mosaicIds) {
      var mosaicIdsBody = {
        mosaicIds: mosaicIds.map(function (id) {
          return id.toHex();
        })
      };
      return this.call(this.namespaceRoutesApi.getMosaicsNames(mosaicIdsBody), function (body) {
        return body.mosaicNames.map(function (mosaic) {
          return new MosaicNames_1.MosaicNames(new MosaicId_1.MosaicId(mosaic.mosaicId), mosaic.names.map(function (name) {
            return new NamespaceName_1.NamespaceName(new NamespaceId_1.NamespaceId(name), name);
          }));
        });
      });
    }
    /**
     * Gets the NamespaceInfo for a given namespaceId
     * @param namespaceId - Namespace id
     * @returns Observable<NamespaceInfo>
     */

  }, {
    key: "getNamespace",
    value: function getNamespace(namespaceId) {
      var _this2 = this;

      return this.call(this.namespaceRoutesApi.getNamespace(namespaceId.toHex()), function (body) {
        return _this2.toNamespaceInfo(body);
      });
    }
    /**
     * Gets a NamespaceInfo merkle for a given namespaceId
     * @param namespaceId - Namespace id
     * @returns Observable<MerkleStateInfo>
     */

  }, {
    key: "getNamespaceMerkle",
    value: function getNamespaceMerkle(namespaceId) {
      return this.call(this.namespaceRoutesApi.getNamespaceMerkle(namespaceId.toHex()), DtoMapping_1.DtoMapping.toMerkleStateInfo);
    }
    /**
     * Gets array of NamespaceName for different namespaceIds
     * @param namespaceIds - Array of namespace ids
     * @returns Observable<NamespaceName[]>
     */

  }, {
    key: "getNamespacesNames",
    value: function getNamespacesNames(namespaceIds) {
      var namespaceIdsBody = {
        namespaceIds: namespaceIds.map(function (id) {
          return id.toHex();
        })
      };
      return this.call(this.namespaceRoutesApi.getNamespacesNames(namespaceIdsBody), function (body) {
        return body.map(function (namespaceNameDTO) {
          return new NamespaceName_1.NamespaceName(NamespaceId_1.NamespaceId.createFromEncoded(namespaceNameDTO.id), namespaceNameDTO.name, namespaceNameDTO.parentId ? NamespaceId_1.NamespaceId.createFromEncoded(namespaceNameDTO.parentId) : undefined);
        });
      });
    }
    /**
     * Gets an array of namespaces.
     * @param criteria - Namespace search criteria
     * @returns Observable<Page<NamespaceInfo>>
     */

  }, {
    key: "search",
    value: function search(criteria) {
      var _this3 = this;

      var _a, _b, _c, _d;

      return this.call(this.namespaceRoutesApi.searchNamespaces((_a = criteria.ownerAddress) === null || _a === void 0 ? void 0 : _a.plain(), (_b = criteria.registrationType) === null || _b === void 0 ? void 0 : _b.valueOf(), (_c = criteria.level0) === null || _c === void 0 ? void 0 : _c.toHex(), (_d = criteria.aliasType) === null || _d === void 0 ? void 0 : _d.valueOf(), criteria.pageSize, criteria.pageNumber, criteria.offset, DtoMapping_1.DtoMapping.mapEnum(criteria.order)), function (body) {
        return _get(_getPrototypeOf(NamespaceHttp.prototype), "toPage", _this3).call(_this3, body.pagination, body.data, _this3.toNamespaceInfo);
      });
    }
  }, {
    key: "streamer",
    value: function streamer() {
      return new paginationStreamer_1.NamespacePaginationStreamer(this);
    }
    /**
     * Gets the MosaicId from a MosaicAlias
     * @param namespaceId - the namespaceId of the namespace
     * @returns Observable<MosaicId | null>
     */

  }, {
    key: "getLinkedMosaicId",
    value: function getLinkedMosaicId(namespaceId) {
      var _this4 = this;

      return this.networkTypeObservable.pipe(operators_1.mergeMap(function () {
        return _this4.call(_this4.namespaceRoutesApi.getNamespace(namespaceId.toHex()), function (body) {
          var namespaceInfoDTO = body;

          if (namespaceInfoDTO.namespace === undefined) {
            // forward catapult-rest error
            throw namespaceInfoDTO;
          }

          if (namespaceInfoDTO.namespace.alias.type.valueOf() === AliasType_1.AliasType.None || namespaceInfoDTO.namespace.alias.type.valueOf() !== AliasType_1.AliasType.Mosaic || !namespaceInfoDTO.namespace.alias.mosaicId) {
            throw new Error("No mosaicId is linked to namespace '".concat(namespaceInfoDTO.namespace.level0, "'"));
          }

          return new MosaicId_1.MosaicId(namespaceInfoDTO.namespace.alias.mosaicId);
        });
      }));
    }
    /**
     * Gets the Address from a AddressAlias
     * @param namespaceId - the namespaceId of the namespace
     * @returns Observable<Address>
     */

  }, {
    key: "getLinkedAddress",
    value: function getLinkedAddress(namespaceId) {
      var _this5 = this;

      return this.networkTypeObservable.pipe(operators_1.mergeMap(function () {
        return _this5.call(_this5.namespaceRoutesApi.getNamespace(namespaceId.toHex()), function (body) {
          var namespaceInfoDTO = body;

          if (namespaceInfoDTO.namespace === undefined) {
            // forward catapult-rest error
            throw namespaceInfoDTO;
          }

          if (namespaceInfoDTO.namespace.alias.type.valueOf() === AliasType_1.AliasType.None || namespaceInfoDTO.namespace.alias.type.valueOf() !== AliasType_1.AliasType.Address || !namespaceInfoDTO.namespace.alias.address) {
            throw new Error("No address is linked to namespace '".concat(namespaceInfoDTO.namespace.level0, "'"));
          }

          var addressDecoded = namespaceInfoDTO.namespace.alias.address;
          var address = format_1.RawAddress.addressToString(format_1.Convert.hexToUint8(addressDecoded));
          return Address_1.Address.createFromRawAddress(address);
        });
      }));
    }
    /**
     * Get rest url
     */

  }, {
    key: "getUrl",
    value: function getUrl() {
      return this.url;
    }
    /**
     * It maps from a NamespaceInfoDTO to NamespaceInfo
     * @param dto the dto
     */

  }, {
    key: "toNamespaceInfo",
    value: function toNamespaceInfo(dto) {
      return new NamespaceInfo_1.NamespaceInfo(dto.namespace.version || 1, dto.meta.active, dto.meta.index, dto.id, dto.namespace.registrationType, dto.namespace.depth, NamespaceHttp.extractLevels(dto.namespace), NamespaceId_1.NamespaceId.createFromEncoded(dto.namespace.parentId), DtoMapping_1.DtoMapping.toAddress(dto.namespace.ownerAddress), UInt64_1.UInt64.fromNumericString(dto.namespace.startHeight), UInt64_1.UInt64.fromNumericString(dto.namespace.endHeight), NamespaceHttp.extractAlias(dto.namespace));
    }
    /**
     * Extract the namespace levels
     *
     * @internal
     * @param namespace
     */

  }], [{
    key: "extractLevels",
    value: function extractLevels(namespace) {
      var result = [];

      if (namespace.level0) {
        result.push(NamespaceId_1.NamespaceId.createFromEncoded(namespace.level0));
      }

      if (namespace.level1) {
        result.push(NamespaceId_1.NamespaceId.createFromEncoded(namespace.level1));
      }

      if (namespace.level2) {
        result.push(NamespaceId_1.NamespaceId.createFromEncoded(namespace.level2));
      }

      return result;
    }
    /**
     * Extract the alias from a namespace
     *
     * @internal
     * @param namespace
     */

  }, {
    key: "extractAlias",
    value: function extractAlias(namespace) {
      if (namespace.alias && namespace.alias.type.valueOf() === AliasType_1.AliasType.Mosaic) {
        return new MosaicAlias_1.MosaicAlias(new MosaicId_1.MosaicId(namespace.alias.mosaicId));
      } else if (namespace.alias && namespace.alias.type.valueOf() === AliasType_1.AliasType.Address) {
        return new AddressAlias_1.AddressAlias(DtoMapping_1.DtoMapping.toAddress(namespace.alias.address));
      }

      return new EmptyAlias_1.EmptyAlias();
    }
  }]);

  return NamespaceHttp;
}(Http_1.Http);

exports.NamespaceHttp = NamespaceHttp;